import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { TOOLBAR_ACTION_SUBJECT_ID } from '@atlaskit/editor-common/analytics';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { separatorStyles, wrapperStyle } from '@atlaskit/editor-common/styles';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import { LogoSvg as AtlassianIntelligenceLogo } from '@atlassian/generative-ai-modal/assets/Logo';
import sharedMessages from '@atlassian/generative-ai-modal/utils/messages';
import { svgIconStyles } from './styles';
import { useEditorToolbarChangeDetector } from './useEditorToolbarChangeDetector';
// This const is derived from the breakpoint where the toolbar hides its icons. It is used to hide the text in the AI button.
// Derived from values from platform/packages/editor/editor-core/src/ui/Appearance/FullPage/MainToolbar.tsx
var AI_BUTTON_WIDTH_BREAKPOINT = 1076;

/**
 * @deprecated This method is deprecated and should be cleaned up once all products using AI
 * are on composable editor.
 */
var deprecatedGetWidthState = function deprecatedGetWidthState(view) {
  var editorWidthPlugin = view.state.plugins.find(function (plugin) {
    return plugin.key === 'widthPlugin$';
  });
  return {
    widthState: editorWidthPlugin === null || editorWidthPlugin === void 0 ? void 0 : editorWidthPlugin.getState(view.state)
  };
};
var shouldShowSeparator = function shouldShowSeparator(node) {
  var _node$previousElement;
  if (!node) {
    return false;
  }
  var prevSeparator = (_node$previousElement = node.previousElementSibling) === null || _node$previousElement === void 0 ? void 0 : _node$previousElement.querySelector(":scope > span:last-child:empty");
  var prevSeparatorVisible = prevSeparator && prevSeparator.clientWidth > 0;
  return !prevSeparatorVisible;
};
export var AtlassianIntelligenceToolbarButton = function AtlassianIntelligenceToolbarButton(_ref) {
  var onClick = _ref.onClick,
    disabled = _ref.disabled,
    ButtonWrapper = _ref.ButtonWrapper,
    api = _ref.api,
    view = _ref.view;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var title = formatMessage(sharedMessages.aiUniversalDescriptor);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSeparator = _useState2[0],
    setShowSeperator = _useState2[1];
  var _useSharedPluginState = useSharedPluginState(api, ['width']),
    widthState = _useSharedPluginState.widthState;
  var shouldShowLabel = widthState !== null && widthState !== void 0 && widthState.width ? widthState.width >= AI_BUTTON_WIDTH_BREAKPOINT : true;
  if (!(widthState !== null && widthState !== void 0 && widthState.width) && view) {
    var _deprecatedGetWidthSt = deprecatedGetWidthState(view),
      deprecatedWidthState = _deprecatedGetWidthSt.widthState;
    shouldShowLabel = (deprecatedWidthState === null || deprecatedWidthState === void 0 ? void 0 : deprecatedWidthState.width) >= AI_BUTTON_WIDTH_BREAKPOINT;
  }
  var callbackRef = function callbackRef(node) {
    var result = shouldShowSeparator(node);
    setShowSeperator(result);
  };
  var button = jsx(ToolbarButton, {
    onClick: onClick,
    buttonId: TOOLBAR_ACTION_SUBJECT_ID.AI,
    "aria-label": title,
    testId: "atlassian-intelligence-toolbar-button",
    title: title,
    iconBefore: jsx(AtlassianIntelligenceLogo, {
      alt: '',
      isDisabled: disabled
    }),
    disabled: disabled
  }, shouldShowLabel && formatMessage(sharedMessages.aiUniversalShortCallToAction));
  var toolbarMutationCount = useEditorToolbarChangeDetector(ButtonWrapper);
  var wrapped = ButtonWrapper ? jsx(ButtonWrapper, {
    key: "".concat(toolbarMutationCount, "-key-wrapper")
  }, button) : button;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    jsx("span", {
      ref: callbackRef,
      css: [wrapperStyle, svgIconStyles]
    }, showSeparator && /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */
    jsx("span", {
      "data-testid": "ai-toolbar-button-seperator",
      css: separatorStyles
    }), wrapped)
  );
};